<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <base-card>
          <v-card-title class="pb-3 template-card-title">
            <div class="template-title-left">
              <div class="card-title mb-0">
                Template Details
              </div>

              <div
                v-if="uploadedAepFile.name"
                class="template-subtitle"
              >
                {{ uploadedAepFile.name }}
                <span v-if="uploadedAepFile.root && uploadedAepFile.root.name">
                  · Root: {{ uploadedAepFile.root.name }}
                  {{ uploadedAepFile.root.compW }}x{{ uploadedAepFile.root.compH }},
                  {{ Number(uploadedAepFile.root.compDur || 0).toFixed(2) }} sec
                  · {{ uploadedAepFile.props.length }} layers
                </span>
              </div>
            </div>

            <div class="template-title-actions">
              <v-chip
                small
                class="mr-2"
                :color="isTemplateProduction ? 'success lighten-5' : 'grey lighten-3'"
                :text-color="isTemplateProduction ? 'success' : 'grey darken-1'"
              >
                {{ isTemplateProduction ? 'Production' : 'Not in Production' }}
              </v-chip>

              <v-btn
                text
                :color="isTemplateProduction ? 'warning' : 'success'"
                :loading="productionLoading"
                class="mr-2"
                @click="toggleTemplateProduction"
              >
                <v-icon left>
                  {{ isTemplateProduction ? 'mdi-minus-circle-outline' : 'mdi-plus-circle-outline' }}
                </v-icon>
                {{ isTemplateProduction ? 'Remove from Production' : 'Add to Production' }}
              </v-btn>

              <v-btn
                v-if="isTemplateProduction"
                text
                color="primary"
                @click="goToProductionTemplate"
              >
                <v-icon left>
                  mdi-factory
                </v-icon>
                Production Card
              </v-btn>
            </div>
          </v-card-title>
          <v-card-text>
            <v-row
              class="mt-0 pt-0"
            >
              <v-col
                cols="12"
                md="4"
                class="pb-0"
              >
                <v-text-field
                  v-model.trim="uploadedAepFile.name"
                  dense
                  label="Name"
                  outlined
                  style="min-width: 350px;"
                  hide-details
                />
              </v-col>
              <v-col
                cols="12"
                md="8"
                class="pb-0 pt-1"
              >
                <p
                  class="mb-1 text-16"
                  style="word-break: break-all;"
                >
                  <a
                    :href="uploadedAepFile.url"
                    target="_blank"
                    class="mr-4"
                  >{{ uploadedAepFile.url }}</a>
                  <br>
                  <span class="pr-1 text--disabled">Root:</span>
                  <span v-if="uploadedAepFile.root.name">
                    {{ uploadedAepFile.root.name }} {{ uploadedAepFile.root.compW }}x{{ uploadedAepFile.root.compH }}, {{ uploadedAepFile.root.compDur.toFixed(2) }} sec
                  </span>
                </p>
              </v-col>
            </v-row>

            <v-divider
              v-if="uploadedAepFile.files.aep"
              class="my-2"
            />

            <v-row
              v-if="uploadedAepFile.files.aep"
              class="mt-0 pt-0"
            >
              <v-col
                cols="12"
                md="4"
                class="pb-0 pt-0"
              >
                {{ uploadedAepFile.files.count }} files
              </v-col>
              <v-col
                cols="12"
                md="4"
                class="pb-0 pt-0"
              >
                DIR: {{ uploadedAepFile.files.dir }}
              </v-col>
              <v-col
                cols="12"
                md="4"
                class="pb-0 pt-0"
              >
                AEP: {{ uploadedAepFile.files.aep }}
              </v-col>
            </v-row>

            <v-divider class="my-2" />

            <v-tabs
              v-model="tab"
              background-color=""
              class="p-b-20"
            >
              <v-tab
                v-for="t in tabs"
                :key="t.name"
              >
                {{ t.name }}
              </v-tab>
            </v-tabs>

            <v-row
              v-if="tab == 0"
              class="table-header"
            >
              <v-col
                cols="12"
                md="5"
                class="mt-0 pt-0 mb-0 pb-1"
              >
                Asset Display Name & Type
              </v-col>
              <v-col
                cols="12"
                md="3"
                class="mt-0 pt-1 pl-0 pr-0 mb-0 pb-1"
              >
                Composition
              </v-col>
              <v-col
                cols="12"
                md="4"
                class="mt-0 pt-1 pl-0 pr-0 mb-0 pb-1"
              >
                Layer
              </v-col>
            </v-row>
            <draggable
              v-if="tab == 0"
              class="list-group"
              :list="uploadedAepFile.props"
              ghost-class="ghost"
              group="people"
              v-bind="dragOptions"
            >
              <transition-group
                type="transition"
                name="flip-list"
              >
                <v-row
                  v-for="(prop, i) in uploadedAepFile.props"
                  :key="prop.layer + i"
                  class="mt-0 pt-0"
                  style="padding-bottom:4px;"
                >
                  <v-col
                    cols="12"
                    md="5"
                    class="mt-0 pt-0 mb-0 pb-0"
                  >
                    <div class="d-flex">
                      <v-icon class="mr-2 pointer">
                        mdi-cursor-move
                      </v-icon>
                      <input
                        v-model="prop.displayName"
                        class="prop-input"
                        style="width: 300px;"
                      >
                      <select
                        v-model="prop.type"
                        class="form-select ml-2"
                        style="width: 80px;"
                      >
                        <option>
                          Text
                        </option>
                        <option>Image</option>
                        <option>Media</option>
                        <option>Audio</option>
                        <option>Video</option>
                      </select>
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    class="mt-0 pt-1 pl-0 pr-0  mb-0 pb-0"
                  >
                    <span>{{ prop.comp }}</span>
                    <span> ({{ prop.compW }}x{{ prop.compH }}), {{ prop.compDur.toFixed(2) }} sec</span>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                    class="mt-0 pt-1 pl-0 pr-0  mb-0 pb-0"
                  >
                    <div class="d-flex justify-space-between">
                      <span>{{ prop.layer }}</span>
                      <v-icon
                        class="ml-2 mr-2 pointer"
                        color="error"
                        @click="removeFromAssets(prop)"
                      >
                        mdi-close
                      </v-icon>
                    </div>
                  </v-col>
                </v-row>
              </transition-group>
            </draggable>

            <v-row
              v-for="(prop, i) in uploadedAepFile.props"
              v-if="tab == 1"
              :key="prop.layer + i"
              class="mt-0 pt-0"
              style="padding-bottom:4px;"
            >
              <v-col
                cols="12"
                md="12"
                class="mt-0 pt-0 mb-0 pb-0"
              >
                <div class="d-flex">
                  <input
                    v-model="prop.displayName"
                    class="prop-input"
                    style="width: 300px;"
                    disabled
                  >
                  <select
                    v-model="prop.type"
                    class="form-select ml-2"
                    style="width: 80px;"
                  >
                    <option>
                      Text
                    </option>
                    <option>Image</option>
                    <option>Media</option>
                    <option>Audio</option>
                    <option>Video</option>
                  </select>

                  <input
                    v-model="prop.defaultValue"
                    class="prop-input m-l-10"
                    style="width: 600px"
                    :disabled="prop.fileLoading"
                  >

                  <div
                    v-if="prop.type !== 'Text'"
                    style="width: 30px;"
                  >
                    <v-file-input
                      v-model="prop.file"
                      hide-input
                      hide-details
                      prepend-icon="mdi-upload"
                      class="p-l-10 p-a-0"
                      accept="image/*,video/*,audio/*"
                      :loading="prop.fileLoading"
                      dense
                      small
                      @change="fileUpload(prop, i)"
                    />
                  </div>
                </div>
              </v-col>
            </v-row>

            <v-row
              v-if="tab == 2"
              class="table-header"
            >
              <v-col
                cols="12"
                md="12"
                class="mt-0 pt-0 mb-0 pb-1"
              >
                <v-text-field
                  v-model.trim="uploadedAepFile.sourceURL"
                  dense
                  outlined
                  append-icon="mdi-link"
                  label="Source URL"
                />
                <v-textarea
                  v-model="uploadedAepFile.description"
                  append-icon="mdi-comment-text"
                  label="Template description"
                  rows="2"
                  auto-grow
                  dense
                  outlined
                  counter
                />
              </v-col>
            </v-row>

            <v-row
              v-if="tab == 0"
              class="table-header"
            >
              <v-col
                cols="12"
                md="12"
                class="mt-0 pt-0 mb-0 pb-1"
              >
                <div class="health-check-checkbox">
                  <input
                    id="health-check"
                    v-model="uploadedAepFile.health_check"
                    type="checkbox"
                    class="health-check-input"
                  >
                  <label
                    for="health-check"
                    class="health-check-label"
                  >
                    Health Check
                  </label>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              :disabled="!isFormValid"
              class="mr-2 mb-2"
              color="success"
              @click="saveAEP()"
            >
              Update Template
            </v-btn>
          </v-card-actions>
        </base-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <base-card :data-loading="fileParsing">
          <v-card-title>
            <div class="card-title mb-0">
              Project structure: {{ uploadedAepFile.name }}
            </div>
          </v-card-title>
          <v-card-text>
            <v-sheet
              max-height="560"
              class="overflow-y-auto"
            >
              <table class="tree-table">
                <thead>
                  <tr>
                    <th />
                    <th>Name</th>
                    <th>Dimension</th>
                    <th>Duration</th>
                    <th>FR</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      v-if="!project.compositions.length"
                      colspan="5"
                      class="pa-4 text--disabled text-center"
                    >
                      No data
                    </td>
                  </tr>
                  <template v-for="comp in project.compositions">
                    <tr
                      :key="comp.id"
                    >
                      <td
                        class="pointer"
                        @click="comp.open = !comp.open"
                      >
                        <span v-if="comp.layers.length && !comp.open">&gt;</span>
                        <span v-if="comp.layers.length && comp.open">v</span>
                      </td>
                      <td>
                        <v-menu
                          v-model="comp.menu"
                          :close-on-content-click="false"
                          :nudge-width="130"
                          offset-x
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <span
                              v-bind="attrs"
                              class="hover-name"
                              v-on="on"
                            >
                              {{ comp.name }}
                            </span>
                          </template>

                          <v-card>
                            <v-list>
                              <v-list-item>
                                <v-list-item-content class="pa-0">
                                  <v-list-item-title>{{ comp.name }}</v-list-item-title>
                                  <v-list-item-subtitle>{{ comp.footage_width }}x{{ comp.footage_height }}, {{ comp.footage_seconds }} sec</v-list-item-subtitle>
                                  <v-list-item-subtitle>{{ comp.layers.length }} layers</v-list-item-subtitle>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>

                            <v-divider class="ma-0" />

                            <v-btn
                              depressed
                              small
                              class="primary--text ma-2 ml-3"
                              color="primary lighten-5"
                              @click="setRootComposition(comp)"
                            >
                              <v-icon
                                left
                                color="primary"
                              >
                                mdi-video
                              </v-icon>
                              Set as Root Composition
                            </v-btn>
                          </v-card>
                        </v-menu>

                        <v-chip
                          v-if="comp.name === uploadedAepFile.root.name"
                          color="primary lighten-5"
                          x-small
                          text-color="primary"
                        >
                          root
                        </v-chip>
                        <i
                          v-if="comp.selected"
                          class="v-icon notranslate text-caption primary--text text--lighten-3 mdi mdi-checkbox-blank-circle theme--light ml-1"
                          style="padding-bottom: 2px;"
                        />
                      </td>
                      <td>{{ comp.footage_width }}x{{ comp.footage_height }}</td>
                      <td>{{ comp.footage_seconds.toFixed(2) }} sec</td>
                      <td>{{ comp.footage_framerate }}</td>
                    </tr>
                    <tr
                      v-for="layer in comp.layers"
                      v-show="comp.open"
                      :key="'layer'+comp.id+'l'+layer.index"
                    >
                      <td />
                      <td class="pl-5">
                        <v-menu
                          v-model="layer.menu"
                          :close-on-content-click="false"
                          :nudge-width="130"
                          offset-x
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <span
                              v-bind="attrs"
                              class="hover-name"
                              v-on="on"
                            >
                              {{ layer.name }}
                            </span>
                          </template>

                          <v-card>
                            <v-list>
                              <v-list-item>
                                <v-list-item-content class="pa-0">
                                  <v-list-item-title>{{ layer.name }}</v-list-item-title>
                                  <v-list-item-subtitle v-if="layer.text">
                                    text layer
                                  </v-list-item-subtitle>
                                  <v-list-item-subtitle>
                                    {{ layer.effects }} effects
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>

                            <v-divider class="ma-0" />

                            <v-btn
                              depressed
                              small
                              class="primary--text ma-2 ml-3"
                              color="primary lighten-5"
                              @click="addToAssets(comp, layer)"
                            >
                              <v-icon
                                left
                                color="primary"
                              >
                                mdi-plus
                              </v-icon>
                              Add to Dynamic Assets
                            </v-btn>
                          </v-card>
                        </v-menu>
                        <span
                          v-if="!layer.name"
                          class="text--disabled"
                        >N/A</span>

                        <i
                          v-if="layer.selected"
                          class="v-icon notranslate text-caption primary--text text--lighten-3 mdi mdi-checkbox-blank-circle theme--light ml-1"
                          style="padding-bottom: 2px;"
                        />
                      </td>
                      <td />
                      <td />
                    </tr>
                  </template>
                </tbody>
              </table>
            </v-sheet>
          </v-card-text>
        </base-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import { aepProjectToJsonAPI, processAEPProject } from '@/store/converters'

  export default {
    name: 'AEPDetails',
    metaInfo: {
      title: 'AEP Details',
    },
    components: {
      draggable,
    },
    data () {
      return {
        fileParsing: false,
        uploadedAepFile: {
          size: 0,
          name: '',
          lastModifiedDate: null,
          url: '',
          project: {
            compositions: [],
          },
          root: { name: '', compDur: 0 },
          props: [],
        },
        project: {
          compositions: [],
        },
        polling: null,
        tab: 0,
        tabs: [
          { name: 'General' },
          { name: 'Default Values' },
          { name: 'Info' },
        ],
        productionLoading: false,

        channelTemplates: [],
        templateChannelsLoading: false,
        templateChannelsLoaded: false,
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      dragOptions () {
        return {
          animation: 200,
          group: 'description',
          disabled: false,
        }
      },
      isFormValid () {
        if (!(this.uploadedAepFile.name.length >= 3 && this.uploadedAepFile.name.length <= 255)) {
          return false
        }
        if (!this.uploadedAepFile.url) {
          return false
        }
        if (!this.uploadedAepFile.root.name) {
          return false
        }
        return true
      },
      isTemplateProduction () {
        return this.uploadedAepFile.isProduction
      },
      hasTemplateChannels () {
        return this.channelTemplates.length > 0
      },
      templateChannelCount () {
        return this.channelTemplates.length
      },
    },
    watch: {
    },
    created () {
      this.getTemplate(this.$route.params.template_id)
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    methods: {
      getTemplate (id) {
        this.$store.commit('setPageLoader')

        const args = {
          'id[eq]': id,
        }
        const req = this.$store.dispatch('aepProjects', args)

        return Promise.all([req])
          .then((res) => {
            const items = res[0] || []
            if (!items.length) {
              this.$router.push({ name: 'DashboardPage' })
              return
            }
            const project = processAEPProject(items[0])
            this.uploadedAepFile = project

            this.loadTemplateChannels(
              project.id,
            )

            const layerMap = {}
            for (let i = 0; i < this.uploadedAepFile.props.length; i += 1) {
              const prop = this.uploadedAepFile.props[i]
              const key = prop.layer + '_' + prop.comp
              layerMap[key] = true
            }

            this.fileParsing = true

            this.$store.dispatch('aepParse', { url: this.uploadedAepFile.url })
              .then((project) => {
                for (let i = 0; i < project.compositions.length; i += 1) {
                  project.compositions[i].open = false
                  project.compositions[i].menu = false
                  project.compositions[i].selected = false

                  for (let j = 0; j < project.compositions[i].layers.length; j += 1) {
                    project.compositions[i].layers[j].selected = false
                    project.compositions[i].layers[j].menu = false

                    const l = project.compositions[i].layers[j]

                    const key = l.name + '_' + project.compositions[i].name
                    // eslint-disable-next-line no-prototype-builtins
                    if (layerMap.hasOwnProperty(key)) {
                      project.compositions[i].selected = true
                      project.compositions[i].layers[j].selected = true
                    }
                  }
                }
                this.project = project
              })
              .catch((errorMsg) => {
                this.$store.commit('showSnackbar', {
                  text: errorMsg,
                  timeout: 6000,
                  color: 'error',
                })
              })
              .finally(() => {
                this.fileParsing = false
              })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
            this.$router.push({ name: 'DashboardPage' })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      setRootComposition (comp) {
        this.uploadedAepFile.root = {
          name: comp.name,
          compW: comp.footage_width,
          compH: comp.footage_height,
          compDur: comp.footage_seconds,
          compFR: comp.footage_framerate,
        }
      },
      addToAssets (comp, layer) {
        for (let i = 0; i < this.uploadedAepFile.props.length; i += 1) {
          const prop = this.uploadedAepFile.props[i]
          if (prop.comp === comp.name && prop.layer === layer.name) {
            return
          }
        }
        this.uploadedAepFile.props.push({
          layer: layer.name,
          displayName: layer.name,
          type: 'text',
          comp: comp.name,
          compW: comp.footage_width,
          compH: comp.footage_height,
          compDur: comp.footage_seconds,
          compFR: comp.footage_framerate,
          defaultValue: '',
          file: null,
          fileLoading: false,

          productionLabel: '',
          productionMode: 'auto_manual',
          productionAutoSource: '',
        })
        comp.selected = true
        layer.selected = true
      },
      removeFromAssets (prop) {
        const index = this.uploadedAepFile.props.indexOf(prop)
        this.uploadedAepFile.props.splice(index, 1)

        for (let i = 0; i < this.project.compositions.length; i += 1) {
          const comp = this.project.compositions[i]
          if (prop.comp !== comp.name) {
            continue
          }

          for (let j = 0; j < comp.layers.length; j += 1) {
            if (prop.layer === comp.layers[j].name) {
              comp.layers[j].selected = false
            }
          }

          let compSelected = false
          for (let j = 0; j < comp.layers.length; j += 1) {
            if (comp.layers[j].selected) {
              compSelected = true
            }
          }
          comp.selected = compSelected
        }
      },
      saveAEP () {
        if (!this.isFormValid) return

        this.$store.commit('setPageLoader')

        const updated = aepProjectToJsonAPI(this.uploadedAepFile)

        this.$store.dispatch('patchAEPProject', updated)
          .then((res) => {
            this.$store.commit('showSnackbar', {
              text: 'The AEP template has been successfully updated',
              timeout: 3000,
              color: 'success',
            })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.$store.commit('resolvePageLoader')
          })
      },
      fileUpload (prop, key) {
        if (prop.fileLoading) return
        prop.fileLoading = true

        const file = new FormData()
        file.append('uploadfile', prop.file, prop.file.name)

        const params = {
          file,
          name: prop.file.name,
        // instanceId: this.channel.instance.id,
        }

        this.$store.dispatch('ftpUpload', params)
          .then((result) => {
            prop.fileLoading = false
            prop.defaultValue = result.url
          })
          .catch((errorMsg) => {
            prop.fileLoading = false
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
      },
      loadTemplateChannels (templateId) {
        if (!templateId) {
          this.channelTemplates = []
          this.templateChannelsLoaded = true
          return
        }

        this.templateChannelsLoading = true
        this.templateChannelsLoaded = false

        const params = {
          'aep.id[eq]': templateId,
        }

        this.$store.dispatch(
          'channelTemplates',
          params,
        )
          .then((result) => {
            if (Array.isArray(result)) {
              this.channelTemplates = result
            } else if (
              result &&
              Array.isArray(result.items)
            ) {
              this.channelTemplates = result.items
            } else {
              this.channelTemplates = []
            }

            this.templateChannelsLoaded = true
          })
          .catch((errorMsg) => {
            this.channelTemplates = []
            this.templateChannelsLoaded = false

            this.$store.commit(
              'showSnackbar',
              {
                text:
                  errorMsg &&
                  errorMsg.message
                    ? errorMsg.message
                    : errorMsg,
                timeout: 6000,
                color: 'error',
              },
            )
          })
          .finally(() => {
            this.templateChannelsLoading = false
          })
      },
      toggleTemplateProduction () {
        if (!this.uploadedAepFile.id) return

        if (this.isTemplateProduction) {
          if (
            this.templateChannelsLoading ||
            !this.templateChannelsLoaded
          ) {
            this.$store.commit(
              'showSnackbar',
              {
                text:
                  'Channel assignments are still being checked. Please try again.',
                timeout: 5000,
                color: 'info',
              },
            )

            return
          }

          if (this.hasTemplateChannels) {
            const channelText =
              this.templateChannelCount === 1
                ? '1 channel'
                : `${this.templateChannelCount} channels`

            this.$store.commit(
              'showSnackbar',
              {
                text:
                  `Cannot remove this template from Production while it is assigned to ${channelText}. ` +
                  'Remove it from all channels first.',
                timeout: 7000,
                color: 'warning',
              },
            )

            return
          }
        }

        this.productionLoading = true
        this.$store.commit('setPageLoader')

        const nextValue = this.isTemplateProduction ? 0 : 1
        const prevValue = this.isTemplateProduction ? 1 : 0

        this.$set(this.uploadedAepFile, 'isProduction', nextValue)

        const updated = aepProjectToJsonAPI(this.uploadedAepFile)

        this.$store.dispatch('patchAEPProject', updated)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: nextValue
                ? 'Template has been added to Production'
                : 'Template has been removed from Production',
              timeout: 3000,
              color: 'success',
            })
          })
          .catch((errorMsg) => {
            this.$set(this.uploadedAepFile, 'isProduction', prevValue)

            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.productionLoading = false
            this.$store.commit('resolvePageLoader')
          })
      },

      goToProductionTemplate () {
        if (!this.uploadedAepFile.id) return

        this.$router.push({
          name: 'ProductionTemplateDetails',
          params: {
            template_id: this.uploadedAepFile.id,
          },
        })
      },
    },
  }
</script>

<style lang="scss">
.tree-table {
  width: 100%;
  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  color: #2c3e50;
}

.tree-table th {
  text-transform: uppercase;
  font-weight: 700;
  padding: 0.3rem;
}

.tree-table tr {
  border-bottom: 0.5px solid silver;
}

.tree-table tbody tr:hover {
}

.tree-table td {
  padding: 0.3rem;
}

.tree-table .hover-name:hover {
  background-color: #eee;
}

.prop-input {
  padding: 2px 5px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.form-select {
  cursor: pointer;
  display: block;
  width: 100%;
  padding: 2px 5px;
  -moz-padding-start: calc(0.75rem - 3px);
  font-weight: 400;
  color: #212529;
  background-color: #e9ecef;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 0.25rem center;
  background-size: 16px 12px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.table-header {
  color: grey;
}

.health-check-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  margin-top: 20px;
}

.health-check-input {
  width: 20px;
  height: 20px;
  accent-color: #4daf4f;
  cursor: pointer;
}

.health-check-label {
  font-weight: 500;
  color: #1f2937;
  cursor: pointer;
  user-select: none;
  padding-top: 6px;
}

.health-check-checkbox:hover .health-check-label {
  color: #4daf4f;
}

.health-check-checkbox :disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.template-card-title {
  align-items: flex-start;
  line-height: 18px;
}

.template-subtitle {
  margin-top: 3px;
  font-size: 14px;
  color: #8a8a8a;
  font-weight: 400;
}

.template-card-title {
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;
  gap: 16px;
}

.template-title-left {
  flex: 1 1 auto;
  min-width: 0;
}

.template-title-actions {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  white-space: nowrap;
  padding-top: 8px;
}

.template-subtitle {
  margin-top: 3px;
  max-width: 100%;
  font-size: 14px;
  color: #8a8a8a;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
